import { FormattedMessage, injectIntl } from 'react-intl';
import React, { cloneElement, useState } from 'react';
import { Box, Tabs } from '@mui/material';
import { TabContext, TabPanel } from '@mui/lab';
import getMessage from '/src/utils/getMessage';
import UserMainInfoPanel from './UserMainInfoPanel';
import UserSummaryPanel, { TabStyle } from './UserSummaryPanel';
import DigiraatiTabButton from './DigiraatiTabButton';
import styled from 'styled-components';
import PasswordChangePanel from './PasswordChangePanel';
import { Helmet } from 'react-helmet';
import UserNotificationPanel from './UserNotificationPanel';

export const StyledTabs = styled(Tabs)`
    .MuiTabs-flexContainer {
      flex-direction: column; 
    }
`;

const components = [
  {
    tabIndex: "0",
    tabLabel: 'userNotifications',
    component: <UserNotificationPanel />,
  },
  {
    tabIndex: "1",
    tabLabel: 'userInfoSummary',
    component: <UserSummaryPanel />,
  },
  {
    tabIndex: "2",
    tabLabel: 'userMainInfoTab',
    component: <UserMainInfoPanel />,
  },
  {
    tabIndex: "3",
    tabLabel: 'changePasswordTab',
    component: <PasswordChangePanel/>,
  },
];

const StyledTabPane = styled(TabPanel)`
    padding-left: 0;
    padding-right: 0;

    @media (max-width: 500px) {
        padding: 0;
    }
    .MuiTabPanel-root {
      padding: 0;
    }
`;


const UserInfoPage = () => {

  const [value, setValue] = useState("0");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="user-info-page">
      <Helmet title={getMessage('userInfoPageHeader')} />

      <h1>
        <FormattedMessage id="userInfoPageHeader" />
      </h1>
      <div>
        <div
          style={{ display: 'flex', flexDirection: 'column' }}
        >
        </div>
        <Box sx={{ maxWidth: '90vw', typography: 'body1', marginRight: '10px' }}>
          <TabContext value={value}>
            <div className="user-info-page--flex">
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <StyledTabs
                value={value}
                slotProps={{
                  indicator: {
                    style: {
                      visibility: 'hidden',
                    },
                  }
                }}
              >
                {components.map(c =>
                  <DigiraatiTabButton
                    tabLabel={getMessage(c.tabLabel)}
                    isSelected={value === c.tabIndex}
                    key={c.tabIndex}
                    value={c.tabIndex}
                    style={TabStyle}
                    handleChange={handleChange}
                  />,
                )}
              </StyledTabs>
            </Box>
            {components.map(item =>
              <StyledTabPane
                key={item.tabIndex}
                value={""+item.tabIndex}
              >
                {cloneElement(item.component, { value: item.tabIndex, index: item.tabIndex })}
              </StyledTabPane>,
            )}
            </div>
          </TabContext>
        </Box>
      </div>
    </div>
  );
};

export default injectIntl(UserInfoPage);
